// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1iF1C","inputWrap":"CustomTip_inputWrap__3WxJb"};